module.exports = __webpack_public_path__ + "static/media/guide_cz.dbb8826e.pdf";